<template>
  <div class="get">
    <Header class="get-header" titles="任务详情"></Header>
    <div class="eva" v-if="content">
      <!-- <div class="eva-title">综合评价</div> -->
      <Rate class="evaluation-star" allow-half readonly v-model="score" :size="18" color="#FF7A15" void-icon="star" void-color="white" />
      <div class="eva-label">
        <div v-for="(stem, index) in scoreList" class="eva-label__eve" :key="'s' + index">
          {{stem}}
        </div>
      </div>
      <div class="eva-content">{{content}}</div>
      <div class="eva-time">{{create_time}}</div>
    </div>
    <div class="mytask-list" >
      <div class="eve-mytask">
        <div class="task-header">
          <div class="task-header__left">{{user.title}}</div>
          <div class="task-header__right">{{user.status}}</div>
        </div>
        <div class="task-main">
          <div class="task-main__left">
            <div class="task-left__type">
              {{user.task_mech}}
            </div>
            <template v-for="item in user.task_tag">
              <div class="task-left__type" v-if="item" :key="item">
                {{item}}
              </div>
            </template>
            <div class="task-left__jin" v-if="user.urgent_level == '紧急'">
              紧急
            </div>
          </div>
          <div class="task-main__right">￥{{user.award | strChange}}</div>
        </div>
        <div class="task-footer">
          <div class="footer-time">
            <span v-if="user.plan_start_time">{{user.plan_start_time.substr(0,10)}}</span>
            <span> ~ </span>
            <span v-if="user.plan_end_time">{{user.plan_end_time.substr(0,10)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="task-tab">
      <router-link :to="{path:'/taskType/details',query: {task_id: $route.query.task_id}}" class="tab-div" replace >任务详情</router-link>
      <router-link class="tab-div" v-if="user.task_tag != 'PAB顾问' && !content" :to="{path:'/taskType/dynamic',query: {task_id: $route.query.task_id}}" replace >任务动态</router-link>
      <router-link class="tab-div" v-if="!content" :to="{path:'/taskType/question',query: {task_id: $route.query.task_id, task_tag: user.task_tag}}" replace >进展反馈</router-link>
    </div>
    <router-view></router-view>
    <div class="get-foo" v-if="!$route.query.type">
      <div class="get-phone" @click="call(user.createby_mobile)" v-if="!content">电话沟通</div>
      <div class="get-task" @click="askChe" v-if="(user.status == '审核未通过' || user.status == '进行中')  && user.task_tag != 'PAB顾问'">申请验收</div>
      <!-- <div class="get-task" @click="checkType" v-if="user.status != '进行中' && user.task_tag != 'PAB顾问'">查看验收结果</div> -->
    </div>
    <div class="get-foo" v-if="!create_time && user.status === '已关闭'">
      <router-link class="go-eva" :to="'/evaluate?task_id=' + $route.query.task_id">评价</router-link>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import { getIdTask, askCheck, getTaskEav } from '@/api/api/task'
import { Toast, Rate } from 'vant'
export default {
  data() {
    return {
      user: {},
      ttime: 0,
      score: 3.5,
      scoreList: [],
      content: null,
      create_time: '1'
    }
  },
  created() {
    var task_id = this.$route.query.task_id
    var uid = this.$route.query.uid
    this.getTask(task_id,uid)
    getTaskEav(task_id).then(res => {
      if (res.data.errorCode == 0) {
        var sco = res.data.data
        this.scoreList = [sco.ability_score, sco.responsibility_score, sco.efficiency_score, sco.communicate_score, sco.result_score]
        this.content = sco.content
        this.create_time = sco.create_time
      }
    })
  },
  mounted() {
    // 浏览时间
  },
  beforeDestroy() {
  },
  components: {
    Header,
    Rate
  },
  methods: {
    getTask(s,id) {
      this.$showLoading()
      getIdTask(s,id).then(data => {
        if (data.data.errorCode == '0') {
          console.log(data.data.data.task_tag)
          data.data.data.task_tag = data.data.data.task_tag.split(',')
          this.user = data.data.data
        }
        this.$hideLoading()
      })
    },
    askChe() {
      var users = {}
      users.task_id = this.user.task_id
      users.title = this.user.title
      users.createby_account = this.user.createby_account
      users.svn_path = this.user.svn_path
      users.from_id = this.user.from_id
      users.plan_start_time = this.user.plan_start_time
      users.plan_end_time = this.user.plan_end_time

      askCheck(users).then(data => {
        if (data.data.errorCode == '0') {
          this.$hideLoading()
          Toast({
            type: 'success',
            message: '申请成功',
            duration: 1000
          })
          this.getTask(this.user.task_id)
        } else {
          Toast({
            type: '',
            message: data.data.errorMsg,
            duration: 1000
          })
        }
      }).finally(() => {
      })
    },
    checkType() {
      this.$showLoading()
      var s = this.$route.query.task_id
      getIdTask(s, this.$route.query.uid).then(data => {
        if (data.data.errorCode == 0) {
          data.data.data.task_tag = data.data.data.task_tag.split(',')
          this.user = data.data.data
          
          this.$hideLoading()
          Toast({
            type: 'text',
            message: data.data.data.status,
            duration: 1500
          })
        }
      })
    },
    call(s) {
      window.location.href = 'tel://'+s+''
    }
  }
}
</script>

<style lang="scss" scope>
.get {
  min-height: 100%;
  padding-top: 44px;
  padding-bottom: 70px;
  background: white;
  .eva {
    background-color: white;
    margin-bottom: 10px;
    text-align: center;
    .evaluation-star {
      margin-top: 10px;
      padding: 4px 35px 6px;
      background-image: url('~@/assets/image/line-star.png');
      background-size: 100% 100%;
      position: relative;
    }
    .eva-label {
      padding: 0 36px;
      .eva-label__eve {
        height: 26px;
        padding: 0 8px;
        margin: 0 6px;
        font-size: 12px;
        margin-top: 10px;
        border-radius: 6px;
        background-color: #F2F2F4;
        text-align: center;
        line-height: 26px;
        display: inline-block;
      }
    }
    .eva-time {
      text-align: right;
      padding: 10px;
      padding-right: 36px;
      font-size: 12px;
      color: #9A9AA4;
    }
    .eva-content {
      padding: 0 36px;
      font-size: 14px;
      padding-top: 20px;
      word-break: break-all;
    }
    .eva-title {
      padding-top: 25px;
      font-size: 15px;
      font-weight: 500;
      padding-bottom: 15px;
    }
  }
  .sizelit {
    font-size: 10px;
  }
  .task-tab {
    background-color: white;
    // border-bottom: 1px solid #DFE2E5;
    display: flex;
    line-height: 22px;
    padding-left: 5px;
    .tab-div {
      margin: 10px 5px 0;
      height: 22px;
      padding: 0 10px;
      color: black;
      display: inline-block;
      background-color: #CACACA;
      color: white;
      border-radius: 5px;
      &.router-link-active {
      background-color: #0286FF;
      }
    }
  }
  .mytask-list {
    .eve-mytask {
      height: 100px;
      display: block;
      background: white;
      margin: 12px 12px 0 12px;
      border-bottom: 2px solid #D8D8D8;
      .task-footer {
        display: flex;
        justify-content: space-between;
        .footer-derl {
          width: 72px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          color: white;
          background: #4464eb;
          border-radius: 2px;
        }
        .footer-type {
          margin-top: 8px;
        }
        .footer-time {
          margin-top: 8px;
          color: #ccc;
        }
      }
      .task-header {
        display: flex;
        justify-content: space-between;
        height: 25px;
        margin-bottom: 6px;
        .task-header__left {
          height:21px;
          font-size:18px;
          font-weight: 700;
          color:rgba(51,51,51,1);
          line-height:21px;
        }
        .task-header__right {
          margin-top: 4px;
          color: #4A90E2;
        }
      }
      .task-main {
      display: flex;
      justify-content: space-between;
      height: 27px;
      margin-bottom: 8px;
      .task-main__right {
        height:25px;
        font-size:20px;
        font-weight:600;
        color:#ff6565;
        line-height:25px;
      }
      .task-main__left {
        display: flex;
        .task-left__type {
          padding: 0 6px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
          background: #099B17;
          font-size: 12px;
          color:white;
          margin-right: 8px;
        }
        .task-left__jin {
          padding: 0 6px;
          height: 20px;
          border-radius: 50%;
          background: #F91400;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color:white;
        }
      }
        
    }
    }
  }
  .get-foo {
    z-index: 99;
    height: 66px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    justify-content: space-evenly;
    // padding:  0 15px;
    color: white;
    display: flex;
    padding-top: 20px;
    // padding-bottom: 10px;
    .go-eva {
      width: 100%;
      color: white;
      background: #4464eb;
      // margin-right: 7.5px;
      font-size:15px;
      text-align: center;
      line-height: 46px;
      border-radius:5px;
    }
    .get-bphone {
      width: 100%;
      color: #ff4331;
      background: #ffd7d4;
      // margin-right: 7.5px;
      font-size:15px;
      text-align: center;
      line-height: 46px;
      border-radius:5px;
    }
    .get-phone {
      width: 50%;
      color: #0286FF;
      border: 2px solid #0286FF;
      background: #E9F2FF;
      // margin-right: 7.5px;
      font-size:15px;
      text-align: center;
      line-height: 46px;
      border-radius:5px;
    }
    .get-task {
      // margin-left: 7.5px;
      font-size:15px;
      text-align: center;
      line-height: 46px;
      border-radius:5px;
      width: 50%;
      background: #0286FF;
    }
  }
  .get-header {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 99;
  }
}
</style>